import React from 'react';

function LoadingSpinner({ message = "Loading..." }) {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem',
      backgroundColor: '#f8f9fa'
    }}>
      <div 
        className="spinner"
        style={{
          width: '40px',
          height: '40px',
          border: '4px solid #e3e3e3',
          borderTop: '4px solid #007bff',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }} 
      />
      <p style={{ marginTop: '1rem', color: '#666' }}>{message}</p>
    </div>
  );
}

export default LoadingSpinner;